import React, { FunctionComponent } from 'react';
import { PersonShowModalFavoriteBrandState } from './types';
import { TextBox } from '../../atoms/textBox';
import { RemainingLength } from '../../atoms/remainingLength';

type Props = & PersonShowModalFavoriteBrandState & {
  onChangeBody: (name: string, value: string) => void;
  onClickBrand: (value: string) => void;
  onDeleteBrand: (value: string) => void;
  onSendBrand: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClearSuggest: () => void;
 };

export const Presentation: FunctionComponent<Props> = ({
  favoriteBrands,
  targetBrand,
  isSearching,
  suggestBrands,
  onChangeBody,
  onClickBrand,
  onDeleteBrand,
  onSendBrand,
  onClearSuggest,
}) => {
  return (
    <div className="person__show__modal__inner" onClick={onClearSuggest}>
      <p className="person__show__modal__inner--title">好きなブランドを入力して保存してください</p>
      <div className="person__show__modal__inner__skills">
        <TextBox
          className='person__show__modal__inner__skills--input'
          placeholder='好きなブランドを入力してください'
          onChanged={onChangeBody}
          name='targetBrand'
          value={targetBrand}
          handleSend={onSendBrand}
          enterKeyHint='done'
          maxLength={255}
        />
        <RemainingLength
          remaining={255 - targetBrand.length}
          className="person__show__modal__inner--hint"
        />
        <ul className={`person__show__modal__inner__skills--suggestions ${suggestBrands.length > 0 ? 'active' : ''}`}>
          {suggestBrands.length > 0 && suggestBrands.map((brand) => (
            <li key={brand.title} onClick={() => onClickBrand(brand.title)}>
              <p className="skill--title">{brand.title}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="person__show__modal__inner__skills--box">
        <p className="semiTitle">追加したブランド</p>
        {favoriteBrands.length > 0 ? (
          <ul>
            {favoriteBrands.map((brand) => (
              <li key={brand}>
                <span>{brand}</span>
                <svg onClick={() => onDeleteBrand(brand)} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z" fill="#19190F"/>
                </svg>
              </li>
            ))}
          </ul>
        ) : (
          <p className="person__show__modal__inner__skills--empty">ブランドはまだ追加されていません</p>
        )}
      </div>
    </div>
  );
};
